/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BR-16_INVENTORY_CONFIRM_MODAL
 * Date:         2026-02-08
 * Modified By:  Cursor
 *
 * Description:
 * Confirmation popup for inventory status. Shows warning about outdated inventory.
 * Three actions: Cancel, Edit Inventory (navigate), Confirm (API call).
 * Matches Figma: node-id=1057-13107
 *
 * File Size Check:
 * - Current: 0 (new file)
 * - Adding: ~75
 * - Projected: 75
 * - Decision: Proceed
 *
 * Typography Compliance:
 * - Utilities used: .u-P2-16
 *
 * Related Files:
 * - client/src/features/dashboard/InventoryStatusBox.tsx
 * - client/src/features/inventory/inventory-page/components/InventoryDeleteModal.tsx (pattern ref)
 */

import React from "react";
import { Modal, Button } from "react-bootstrap";

interface InventoryConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  onEditInventory: () => void;
  isConfirming: boolean;
}

const InventoryConfirmModal: React.FC<InventoryConfirmModalProps> = ({
  show,
  onHide,
  onConfirm,
  onEditInventory,
  isConfirming,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm inventory update</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="u-P2-16 mb-0">
          By confirming, you verify that all listed items are currently available
          and accurate. Outdated inventory may lead to missed opportunities and
          buyer frustration.
        </p>
      </Modal.Body>
      <Modal.Footer>
        {/* [2026-02-08] BR-16: Three-button layout matching Figma */}
        <Button variant="outline-secondary" onClick={onHide} disabled={isConfirming}>
          Cancel
        </Button>
        <Button variant="outline-secondary" onClick={onEditInventory} disabled={isConfirming}>
          Edit Inventory
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={isConfirming}>
          {isConfirming ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Confirming...
            </>
          ) : (
            "Confirm"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InventoryConfirmModal;
